import React, { useEffect, useState } from "react";
import { VALIDATIONS, VALIDATIONS_TEXT } from "../../../../app-constants";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Link } from "gatsby";
import BannerForm from "../../components/bannerfrom";
import Img1 from "../../../images/landing/awards/1.webp";
import Img2 from "../../../images/landing/awards/2.webp";
import Img3 from "../../../images/landing/awards/3.webp";
import Img4 from "../../../images/landing/awards/4.webp";
import Img5 from "../../../images/landing/awards/5.webp";
import Img6 from "../../../images/landing/awards/6.webp";
import Img7 from "../../../images/landing/awards/7.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import TekLoader from "../../../images/Tek-Spinner.gif";

const BannerLanding = () => {

  const getBaseUrl = () => {
    if (
      typeof window !== "undefined" &&
      (window.location.href.includes(
        "https://staging-tekrevol.tekstagearea.com"
      ) ||
        window.location.href.includes("http://localhost:8000") ||
        window.location.href.includes("http://localhost:9000"))
    ) {
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    } else {
      // return "https://tekrevol.tekstagearea.com/api/v1/contact-form";
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    }
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [Success, SetSuccess] = useState(false);
  const [Loading, SetLoading] = useState(false);
  const onSubmit = async (data) => {
    const url = window.location.href;
    data.form_path = url.split("?")[0];
    SetLoading(true);

    const baseUrl = getBaseUrl(); // Get the base URL
    const response = await axios.post(baseUrl, data);

    // const response = await axios.post(
    //   `https://tekrevol.tekstagearea.com/api/v1/contact-form`,
    //   data
    // );
    SetSuccess(true);
    setTimeout(() => {
      SetSuccess(false);
    }, 2000);
    SetLoading(false);
    reset({
      name: "",
      email: "",
      phone: "",
    });
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const slides = [Img1, Img2, Img3, Img4, Img5, Img6, Img7];

  const duplicatedSlides = [...slides, ...slides, ...slides];

  return (
    <>
      <section className="banner_lp">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
              <h1>
                <span>#1 Web</span> Development Company
              </h1>
              <p>
                Transformative builders of innovation. We shape technology into
                revolutionary web experiences, fueled by your unique vision.
              </p>
              <Link
                to="#"
                className="lp_btn"
                aria-label="TekRevol Contact"
                onClick={handleShow}
              >
                Let’s Talk
              </Link>

              <Swiper
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Navigation, Autoplay, Pagination]}
                breakpoints={{
                  320: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                  1400: {
                    slidesPerView: 5,
                  },
                  1600: {
                    slidesPerView: 5,
                  },
                }}
                className="carousel_banner_awards"
              >
                {duplicatedSlides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <div className="featured_item">
                      <div className="banner_lp_img">
                        <LazyLoadImage
                          src={slide}
                          effect="blur"
                          alt="tekrevol"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <div className="lp_form">
                <h5>Let's start a Project Together</h5>
                <Form
                  className="lp_form_inner"
                  onSubmit={handleSubmit(onSubmit)}
                  method="POST"
                >
                  <Form.Group className="lp_from_item">
                    <Form.Control
                      type="text"
                      placeholder="Full Name"
                      name="name"
                      {...register("name", {
                        maxLength: {
                          value: VALIDATIONS.NAME,
                          message: VALIDATIONS_TEXT.NAME_MAX,
                        },
                        required: {
                          value: true,
                          message: VALIDATIONS_TEXT.NAME_REQUIRED,
                        },
                      })}
                    />
                    {errors.name && (
                      <span className="error_tek">{errors.name?.message}</span>
                    )}
                  </Form.Group>
                  <Form.Group className="lp_from_item">
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      name="email"
                      {...register("email", {
                        maxLength: {
                          value: VALIDATIONS.EMAIL,
                          message: VALIDATIONS_TEXT.EMAIL_MAX,
                        },
                        required: {
                          value: true,
                          message: VALIDATIONS_TEXT.EMAIL_REQUIRED,
                        },
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: VALIDATIONS_TEXT.EMAIL_FORMAT,
                        },
                      })}
                    />
                    {errors.email && (
                      <span className="error_tek">{errors.email?.message}</span>
                    )}
                  </Form.Group>
                  <Form.Group className="lp_from_item">
                    <Form.Control
                      type="tel"
                      placeholder="Number"
                      name="phone"
                      {...register("phone", {
                        pattern: {
                          // value: /^\+?\d*$/,
                          value: /^\d+$/,
                          message: VALIDATIONS_TEXT.NUMBER_PHONE_FORMAT,
                        },
                        // minLength: {
                        //   value: VALIDATIONS.PHONE_MIN,
                        //   message: VALIDATIONS_TEXT.PHONE_MIN,
                        // },
                        // maxLength: {
                        //   value: VALIDATIONS.PHONE_MAX,
                        //   message: VALIDATIONS_TEXT.PHONE_MAX,
                        // },
                        required: {
                          value: true,
                          message: VALIDATIONS_TEXT.PHONE_REQUIRED,
                        },
                      })}
                    />
                    {errors.phone && (
                      <span className="error_tek">{errors.phone?.message}</span>
                    )}
                  </Form.Group>
                  <Form.Group className="lp_from_item">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="description"
                      placeholder="Describe Your Project Need."
                      {...register("description", {
                        maxLength: {
                          value: VALIDATIONS.DESCRIPTION_MAX,
                          message: VALIDATIONS_TEXT.DESCRIPTION_MAX,
                        },
                        required: {
                          value: true,
                          message: VALIDATIONS_TEXT.DESCRIPTION_REQUIRED,
                        },
                      })}
                    />
                    {errors.description && (
                      <span className="error_tek">
                        {errors.description?.message}
                      </span>
                    )}
                  </Form.Group>

                  {!Loading ? (
                    <Button
                      variant="primary"
                      className="btn_submit"
                      type="submit"
                    >
                      Let’s Talk
                    </Button>
                  ) : (
                    <img
                      src={TekLoader}
                      alt="img_looder"
                      className="img-fluid looder_img"
                    />
                  )}
                </Form>
                {Success ? (
                  <div className="alert-success">
                    Thank you for your message. It has been sent.
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default BannerLanding;
